import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  position: relative;\n  width: ", ";\n  stroke: ", ";\n  .cls-1,\n  .cls-4,\n  .cls-5 {\n    fill: none;\n  }\n  .cls-2 {\n    fill: red;\n    clip-path: url(#clip-path);\n  }\n  .cls-3 {\n    clip-path: url(#clip-path-2);\n  }\n  .cls-4,\n  .cls-5 {\n    stroke-miterlimit: 10;\n  }\n  .cls-4 {\n    stroke-width: ", ";\n  }\n  .cls-5 {\n    stroke: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
var propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  selected: PropTypes.bool,
  //DEPRECATED
  checked: PropTypes.bool
};
var defaultProps = {
  disabled: false,
  error: false,
  height: 20,
  width: 20
};

var getValidationState = function getValidationState(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error;

  if (disabled) {
    return colors.coolGray3;
  }

  if (error) {
    return colors.orange;
  }

  return colors.black;
};

var StyledCheckboxSVG = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledCheckboxSVG",
  componentId: "sc-13p9c2-0"
})(_templateObject(), calculateRem(20), calculateRem(20), function (props) {
  return getValidationState(props);
}, calculateRem(2), function (props) {
  return props.disabled ? colors.coolGray3 : colors.black;
});
/**
 * @ignore
 */

var CheckboxIcon = function CheckboxIcon(props) {
  var selected = props.checked || props.selected || false;
  return /*#__PURE__*/React.createElement(StyledCheckboxSVG, _extends({}, props, {
    viewBox: "0 0 22 22",
    height: props.height,
    width: props.width,
    focusable: "false"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: "20",
    height: "20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: "68",
    height: "20"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: "1",
    y: "1",
    width: "20",
    height: "20"
  }))), selected && /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 7)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "0.388 3.8068 3.511 7.1 9.61 0.55"
  })));
};

CheckboxIcon.defaultProps = defaultProps;
CheckboxIcon.propTypes = propTypes;
export default CheckboxIcon;